export default __webpack_public_path__ + "static/media/cardboard_chair.76d2ba58.jpg";